<template>
  <div class="app app--error">
    <NuxtLayout>
      404 Page not found: {{ $route.fullPath }}

      
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
defineProps({
  error: {
    type: Object,
    required: true,
  },
})

const { pageView } = useDataLayer()
pageView('404', '404 Page not found')
</script>
